import permissions from 'application/detail/permissions.json';
import { getCallerShortNameApplicationInParam, getShortNameOfSubflowInParam, stateParamHasSubflow, } from 'modules/application/detail/portal-submodule-builder/templates/builder/subflow/StateParamInterpreter';
import { DEFAULT_CLUSTER_NAME } from 'modules/application/detail/home/homeConstants';
import { ChannelsFeatures } from 'modules/application/detail/channels/ChannelsFeatures';
export class CurrentApplicationService {
    static $inject = ['AuthenticationService', 'ApplicationService2', 'ChannelsService', '$stateParams', 'ngToast', '$translate', 'HostingService', 'CacheService', 'SubflowService', 'MessagingHubService', 'TenantService', 'AnswersService'];
    constructor(AuthenticationService, ApplicationService2, ChannelsService, $stateParams, ngToast, $translate, HostingService, CacheService, SubflowService, MessagingHubService, TenantService, AnswersService) {
        'ngInject';
        this.AuthenticationService = AuthenticationService;
        this.ApplicationService2 = ApplicationService2;
        this.ChannelsService = ChannelsService;
        this.$stateParams = $stateParams;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.HostingService = HostingService;
        this.CacheService = CacheService;
        this.SubflowService = SubflowService;
        this.MessagingHubService = MessagingHubService;
        this.TenantService = TenantService;
        this.AnswersService = AnswersService;
    }
    async fetchApplication(shortName) {
        if (stateParamHasSubflow(this.$stateParams)) {
            return;
        }
        let application;
        shortName = shortName || this.$stateParams.shortName;
        application = await this.CacheService.getOrAdd(shortName, async () => {
            try {
                application = await this.ApplicationService2.getApplication(shortName);
                application.aiAnswersEnabled = await this.AnswersService.isEnabled();
                const useConfigurationApplicationGet = await ChannelsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
                const useGatewayConfigurationsEndpoint = await ChannelsFeatures.isGatewayConfigurationsFromNewEndpointEnabled();
                application.channels = await this.ChannelsService.getAllChannels(useConfigurationApplicationGet, useGatewayConfigurationsEndpoint);
                const templateIsNotDefined = !application.template || application.template === 'undefined' || application.template === 'webhook';
                const applicationJson = templateIsNotDefined
                    ? application
                    : await this.HostingService.getApplicationJson(application);
                application.applicationJson = applicationJson;
                return application;
            }
            catch (err) {
                const errorMsg68 = await this.$translate('applicationError.generic');
                this.ngToast.danger(errorMsg68);
                console.error('Plugin load error', err);
                throw err;
            }
        });
        return application;
    }
    async fetchSubflowApplication(shortName, callerShortName, resetClient = true) {
        let application;
        let getApplicationInCache = true;
        application = await this.CacheService.getOrAdd(`${shortName}:${callerShortName}`, async () => {
            try {
                getApplicationInCache = false;
                //TODO: Implement MessagingHubService.resetClient without the need for a bot appplication
                //It is necessary to call the MessagingHubService.resetClient after the SubflowService.get because the SubflowService.get needs
                //a valid blip sdk client configuration.
                const callerApplication = callerShortName ? await this.ApplicationService2.getApplication(callerShortName) : undefined;
                if (callerApplication && resetClient) {
                    await this.MessagingHubService.resetClient(callerApplication);
                }
                const subflow = await this.SubflowService.get(shortName);
                const application = this.generateSubflowApplication(subflow);
                application.callerApplication = callerApplication;
                const tenantInfo = await this.TenantService.getTenantPlanAndCluster(application.tenantId);
                application.plan = tenantInfo.planName;
                application.cluster = tenantInfo.clusterName;
                await this.MessagingHubService.resetClient(application);
                const useConfigurationApplicationGet = await ChannelsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
                const useGatewayConfigurationsEndpoint = await ChannelsFeatures.isGatewayConfigurationsFromNewEndpointEnabled();
                application.channels = await this.ChannelsService.getAllChannels(useConfigurationApplicationGet, useGatewayConfigurationsEndpoint);
                application.applicationJson = await this.HostingService.getApplicationJson(application);
                return application;
            }
            catch (err) {
                const errorMsg68 = await this.$translate('applicationError.generic');
                this.ngToast.danger(errorMsg68);
                console.error('Plugin load error', err);
                throw err;
            }
        });
        if (!getApplicationInCache && (resetClient === undefined || resetClient)) {
            await this.MessagingHubService.resetClient(application);
        }
        return application;
    }
    async fetchApplicationByStateParams(resetClient = false) {
        if (stateParamHasSubflow(this.$stateParams)) {
            return this.fetchSubflowApplication(getShortNameOfSubflowInParam(this.$stateParams), getCallerShortNameApplicationInParam(this.$stateParams), resetClient);
        }
        else {
            return this.fetchApplication(this.$stateParams.shortName);
        }
    }
    generateSubflowApplication(subflow) {
        const readWritePermission = 3;
        return {
            shortName: subflow.shortName,
            name: subflow.configuration.name,
            imageUri: subflow.configuration.image,
            description: subflow.configuration.description,
            emailOwner: '',
            accessKey: '',
            hasPermission: true,
            isTemplate: true,
            isSubflow: true,
            status: 'online',
            template: 'builder',
            updated: (new Date()).toISOString(),
            created: (new Date()).toISOString(),
            tenantId: subflow.configuration.tenantId ?? DEFAULT_CLUSTER_NAME,
            applicationUserPermissionModel: Object.keys(permissions).reduce((filtered, permission) => {
                const permissionObject = permissions[permission];
                const exceptionsClaims = [101, 109, 110, 112];
                if (!exceptionsClaims.includes(permissionObject.claim)) {
                    filtered.push({
                        permissionClaim: permissionObject.claim,
                        permissionAction: readWritePermission,
                    });
                }
                return filtered;
            }, []),
        };
    }
}
CurrentApplicationService.$inject = ['AuthenticationService', 'ApplicationService2', 'ChannelsService', '$stateParams', 'ngToast', '$translate', 'HostingService', 'CacheService', 'SubflowService', 'MessagingHubService', 'TenantService', 'AnswersService'];
